import React, { useState } from "react";
import PartIIIStyle from "./partiii.module.css";
import { Button, Col, Form, Input, Row, Select, Table, Carousel } from "antd";
import SwiperList from "../../json/swiper";
import { methy_DM_level, ChangeDmOptions } from "../../json/methy_DM_level";
import { ReactComponent as LeftIcon } from "../../../../assets/icon/左 左.svg";
import { ReactComponent as RightIcon } from "../../../../assets/icon/右 右.svg";
const contentStyle = {
  margin: 0,
  color: "#fff",
  textAlign: "center",
  color: "black",
};
function Part_III() {
  const [SwiperList, setSwiperList] = useState({
    CA12DAP_1:
      "/api/static/methy/methy_DM_level/CA12DAP_1.mCX_methlevel_distribution.png",
    CA12DAP_2:
      "/api/static/methy/methy_DM_level/CA12DAP_2.mCX_methlevel_distribution.png",
    CA12DAP_3:
      "/api/static/methy/methy_DM_level/CA12DAP_3.mCX_methlevel_distribution.png",
    CA15DAP_1:
      "/api/static/methy/methy_DM_level/CA15DAP_1.mCX_methlevel_distribution.png",
    CA15DAP_2:
      "/api/static/methy/methy_DM_level/CA15DAP_2.mCX_methlevel_distribution.png",
    CA15DAP_3:
      "/api/static/methy/methy_DM_level/CA15DAP_3.mCX_methlevel_distribution.png",
    CA9DAP_1:
      "/api/static/methy/methy_DM_level/CA9DAP_1.mCX_methlevel_distribution.png",
    CA9DAP_2:
      "/api/static/methy/methy_DM_level/CA9DAP_2.mCX_methlevel_distribution.png",
    CA9DAP_3:
      "/api/static/methy/methy_DM_level/CA9DAP_3.mCX_methlevel_distribution.png",
    ZY12DAP_1:
      "/api/static/methy/methy_DM_level/ZY12DAP_1.mCX_methlevel_distribution.png",
    ZY12DAP_2:
      "/api/static/methy/methy_DM_level/ZY12DAP_2.mCX_methlevel_distribution.png",
    ZY12DAP_3:
      "/api/static/methy/methy_DM_level/ZY12DAP_3.mCX_methlevel_distribution.png",
    ZY15DAP_1:
      "/api/static/methy/methy_DM_level/ZY15DAP_1.mCX_methlevel_distribution.png",
    ZY15DAP_2:
      "/api/static/methy/methy_DM_level/ZY15DAP_2.mCX_methlevel_distribution.png",
    ZY15DAP_3:
      "/api/static/methy/methy_DM_level/ZY15DAP_3.mCX_methlevel_distribution.png",
    ZY9DAP_1:
      "/api/static/methy/methy_DM_level/ZY9DAP_1.mCX_methlevel_distribution.png",
    ZY9DAP_2:
      "/api/static/methy/methy_DM_level/ZY9DAP_2.mCX_methlevel_distribution.png",
    ZY9DAP_3:
      "/api/static/methy/methy_DM_level/ZY9DAP_3.mCX_methlevel_distribution.png",
  });
  const onFinish = (values) => {
    setSwiperList(methy_DM_level[values.tissue]);
  };
  return (
    <div>
      <div className={PartIIIStyle.Epigenome_Header}>
        <p>Changes in organizational methylation levels</p>
      </div>
      {/* <div className={PartIIIStyle.Changes_form}>
        <Form
          style={{ width: "90%", margin: "auto" }}
          onFinish={onFinish}
          initialValues={{ tissue: "Leaf" }}
        >
          <Row>
            <Col span={6}>
              <Form.Item
                label={<span style={{ fontWeight: "bold" }}>Tissue</span>}
                name="tissue"
              >
                <Select style={{ width: 200 }} options={ChangeDmOptions} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item>
                <Button
                  htmlType="submit"
                  style={{
                    background: "#076A09",
                    border: "none",
                    color: "white",
                  }}
                >
                  Submit
                </Button>
              </Form.Item>
            </Col>
            <Col span={6}></Col>
            <Col span={6}></Col>
          </Row>
        </Form>
        <div style={{width:"90%",margin:"0 auto",display:"flex",alignItems:"center"}}>
          <p style={{margin: "0 10px",fontWeight:"bold"}}>Tissue:</p>
          <Select style={{ width: 200 }} options={ChangeDmOptions} defaultValue={"Leaf"} onChange={(e)=>{
            setSwiperList(methy_DM_level[e]);
          }} />
        </div>
      </div> */}
      <div className={PartIIIStyle.Epigenome_Swiper}>
      
        <Carousel
          dots={false}
          arrows={true}
          slidesToScroll={1}
          slidesToShow={
            SwiperList && Object.keys(SwiperList).length < 2 ? 1 : 6
          } // 如果图片数量少于2个，显示1个
          infinite={true}
          nextArrow={<RightIcon />}
          prevArrow={<LeftIcon />}
        >
          {Object.keys(SwiperList).map((key) => {
            return (
              <div
                key={key}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <h3 style={contentStyle}>
                  <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                  }}
                  >
                  <img
                    src={`${SwiperList[key]}`}
                    style={{
                      width:
                        Object.keys(SwiperList).length < 2 ? "15.89%" : "95%",
                      margin: "0 5px",
                    }}
                    alt=""
                  />
                  <p
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                  }}
                >
                  {key}
                </p>
                  </div>
                 
                </h3>
               
              </div>
            );
          })}
        </Carousel>
      </div>
    </div>
  );
}

export default Part_III;
